import React from 'react';
import { AppInitialize } from './components/AppInitialize';

const App = () => {
  return <AppInitialize />;
};

export default App;
